var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.wrapperClass]},[(!_vm.showError)?_c('nuxt-img',{class:[_vm.imageClass],attrs:{"alt":_vm.alt,"src":_vm.imageUrl},on:{"error":_vm.onError}}):_c('avatar',{attrs:{"color":"#FFFFFF","username":_vm.alt,"rounded":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }